export const operatorOptions = [
  { key: 'is', text: 'is', value: 'is' },
  { key: 'is_not', text: 'is not', value: 'is_not' },
];

export const demographicsAttributeOptions = [
  { key: 'age', text: 'Age', value: 'age' },
  { key: 'gender', text: 'Gender', value: 'gender' },
  { key: 'ethnicity', text: 'Ethnicity', value: 'ethnicity' },
  { key: 'country', text: 'Country', value: 'country' },
  { key: 'householdIncome', text: 'Household Income', value: 'householdIncome' },
  { key: 'state', text: 'State', value: 'state' },
];

export const demographicsAttributes = ['age', 'gender', 'ethnicity', 'country', 'householdIncome', 'state'];

export const questionTypeRanking = 'ranking';

export const questionTypeMatrix = 'matrix';
